import React from 'react'
import {withRouter} from 'next/router'
import EventAPI from '../api/EventAPI'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import moment from 'moment-timezone'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import BookingModal from '../components/BookingModal'
import { MdLocationOn } from 'react-icons/md'
import Card from 'react-bootstrap/Card'
import Layout from '../components/Layout'
import Divider from '../components/Divider'
import CommentCell from '../components/CommentCell'
import VideoCell from '../components/VideoCell'
import Router from 'next/router'
import {connect} from "react-redux";
import VideoPlayerModal from '../components/VideoPlayerModal'
import ReactGA from 'react-ga'
import EventTelemetryOverlay from '../components/EventTelemetryOverlay'
import {AnalyticsManager, events} from '../api/Analytics'
import LiveViewButton from '../components/LiveViewButton'
import { consoleLog, print } from '../managers/Logger'
import Head from 'next/head'
import UserCellView from '../components/UserCellView'
import ReactPixel from 'react-facebook-pixel';
import Constants from '../components/Constants'
import UtilsManager from '../managers/UtilsManager'
import ItemRow from '../components/ItemRow'
import DownloadPlug from '../components/DownloadPlug'
import MetricsManager from '../managers/MetricsManager'
import Badge from 'react-bootstrap/Badge'
import ZoneAPI from '../api/ZoneAPI'
import { getSelectorsByUserAgent } from 'react-device-detect'
import { canoc } from '../managers/Utils'

class Event extends React.Component { 

  	constructor(props){
  		super(props)
  		print(props)
  		this.state = {	 
  			event: props.event,
  			show: false,
  			showNoTicket: false,
  			showStory: false,
  			videoUrl: null, 
  			embed: false, 
  			fakeData: false,
  			share: false,
  			username: null,
  			loaded: false, 
  			similarEvents: [],
			config: null
  		}

  		this.eventApi = new EventAPI(this.props.auth)
  		this.utilsManager = new UtilsManager();
		this.metricsManager = new MetricsManager();
		this.zoneApi = new ZoneAPI(this.props.auth);
		this.deviceInfo = getSelectorsByUserAgent(props.userAgent);
	  }
	  
	  static async getInitialProps(context) { 
		var { id, aff } = context.query
		const regex = /(\d+$)/
		var matches = id.match(regex);
		if (matches !== null && matches !== undefined && matches.length !== 0 ) { 
			id = matches[0]
		} 
		const eventApi = new EventAPI(context.auth)
		const utilsManager = new UtilsManager();
		const result = await eventApi.getEvent(id)
		if (result.code == -1 || result == null || result == undefined) { 
			if (context.req) { 
				context.res.redirect("/o/" + id)
			} else { 
				Router.push("/o/" + id)
			}
		}

		const props = {event: result, aff: aff}

		const eventZoneSlug = utilsManager.getZoneSlug(result)

		const similarEvents = await eventApi.getEventsV2({zone: eventZoneSlug, 
			category: result.kind, 
			exclude_ids: [result.id], 
			orderBy: '-rank',
			expansions: 'tags'
		})

		if (similarEvents !== null && similarEvents !== undefined) { 
			props.similarEvents = similarEvents.results
		}

		const isEventbriteEvent = props.event.external_url && props.event.external_url.includes("eventbrite.com")

		const jsonLdString = {
			"@context": "https://schema.org",
			"@type": "Event",
			name: props.event.title,
			startDate: props.event.start_date,
			endDate: props.event.end_date,
			location: {
				"@type": "Place",
				name: props.event.place,
				address: {
					"@type": "PostalAddress",
					streetAddress: props.event.address
				}
			  },
			  image: [
					props.event.image_url
			  ],
			  description: props.event.description,
			  eventAttendanceMode: props.event.online ? "https://schema.org/OnlineEventAttendanceMode" : "https://schema.org/OfflineEventAttendanceMode",
			  eventStatus: "https://schema.org/EventScheduled",
			  offers: {
				"@type": "Offer",
				url: isEventbriteEvent ? "https://www.witheta.com/event/" + canoc(props.event.title, props.event.id) : props.event.external_url,
				price: props.event.cost,
				priceCurrency: "USD"
			}
		}
		
		return {event: result, aff: aff, similarEvents: similarEvents.results, jsonLdStr: JSON.stringify(jsonLdString)}
	}

	async componentDidMount() { 
		this.setState({loaded: true})
		const type = this.props.router.query.type
		var aff = this.props.router.query.aff
		print("affiliation is ")
		print(aff)

		var action = 'view'

		if (type == 'embed') { 
			action += "-embed"
			this.setState({embed: true})
		} else if (type == 'victor-fake-xxx1995') { 
			this.setState({fakeData: true})
		} else if (type === "share") { 
			action += "share"
			const username = this.props.router.query.username
			if (username !== null && username !== undefined) { 
				this.setState({share: true, username: username})
			} else { 
				this.setState({share: true})
			}
		}

		ReactGA.initialize('UA-139931598-1')
		ReactGA.pageview(window.location.pathname + window.location.search);
		ReactGA.event({
			category: 'Event',
			action: action,
			value: this.props.event.id,
			label: this.props.event.id.toString()
		});
		this.metricsManager.logEvent("page_view", {label: "event", eventId: this.props.event.id, source: aff, action: action})

		ReactPixel.init('1603426606357869');
		ReactPixel.pageView(); 

		var params = null
		if (type == 'embed') { 
			params = {source: 'Embed'}
		} else { 
			if (aff === null || aff === undefined) { 
				aff = "direct"
			}
			params = {source: aff}
		}

		if (this.props.event == null || this.props.event == undefined) { 
			return 
		}

		AnalyticsManager.logEvent(events.EVENT_VIEW, {
			event_id: this.props.event.id,
			params: JSON.stringify(params),
			source: params['source']
		})


		const zoneConfig = await this.zoneApi.getConfig(["client"])
		consoleLog("Zone config is ===")
		consoleLog(zoneConfig)
		if (zoneConfig !== null && zoneConfig.code !== -1) { 
			this.setState({config: zoneConfig})
		}

		window.scrollTo(0, 0)
	}

	getStartTimeAndEndDate() { 
		const event = this.props.event
		const timeZone = this.utilsManager.getTimeZone(this.props.event, true)
		const startFormat = moment.tz(event.start_date, timeZone).format('ddd MMM Do')
		const endFormat = moment.tz(event.end_date, timeZone).format('ddd MMM Do')
		return startFormat + " - " + endFormat
	}


	getStartTimeAndEndTime() { 
		const event = this.props.event
		const timeZone = this.utilsManager.getTimeZone(this.props.event, true)
		const startFormat = moment.tz(event.start_date, timeZone).format('ddd MMM Do, h:mm a z')
		const endFormat = moment.tz(event.end_date, timeZone).format('h:mm a z')
		return startFormat + " - " + endFormat
	}

	handleClose() { 
		this.setState({show: false})
	}


	getChat() { 
		if (this.props.event.comments.length != 0 && this.isForTheCultureEvent()) { 
			return (<div>
				<h3 style={{marginBottom:20}}> Chat </h3>
				{this.props.event.comments.map((item, index) => (
						<CommentCell key={index}
						comment={item}/>))}
				<p style={{marginTop:10}}>To join the chat, download the Movement mobile app </p>
				<Divider />
				</div>)

		} else { 
			return null
		}
	}

	handleClickVideo(vidUrl) { 
		ReactGA.event({ 
			category: 'Video',
			action: 'view',
			label: 'event_page',
			value: this.props.event.id
		})

		this.setState({videoUrl: vidUrl, showStory: true})
	}

	getVideos() { 
		if (this.props.event.videos.length != 0) { 
			return (
				<div>
				<h3 style={{marginBottom:20}}>Videos</h3>
				<div style={{display: 'flex'}}>
				{this.props.event.videos.map((item) => (
					<VideoCell 
					key={item.id}
					style={{marginRight: 5}}
					video={item}
					onClick={(vidUrl, eventUrl)=>
					this.handleClickVideo(vidUrl)
					}
					/>))}
				</div>
				</div>
				)
		} else { 
			return null
		}
	}

	getInformationModal() { 
		return (
			<Modal
			show={this.state.showNoTicket} onHide={()=>this.setState({showNoTicket:false})}>
			  <Modal.Header closeButton>
			  		       <Modal.Title>No Need To RSVP </Modal.Title>
		      </Modal.Header>
		       <Modal.Body>
		       <p>This event keeps it old school. </p> 
		       <p> Just show up and have a good time! </p></Modal.Body>
       	 </Modal>
			)
	}

	handleClickBook() {
		ReactGA.event({ 
			category: 'Event',
			action: 'get_ticket',
			label: 'event_page'
		})
		this.metricsManager.logEvent("get_tickets_click", {})
		const isEventbriteEvent = this.props.event.external_url.includes("eventbrite.com")

		if (this.state.event.ticket_groups != null && this.state.event.ticket_groups.length > 0) { 
			this.setState({show: true})
			return 
		}
		if (this.props.event.external_url != null && this.props.event.external_url != '') { 
			window.location.href = this.props.event.external_url;
		} else { 
			this.setState({showNoTicket: true})
		}
	}

	getTips() { 
		if (this.props.event.tips != null) { 
			return (<div>	
					<h3> Our Tips </h3>
						<p> {this.props.event.tips} </p>
						</div>)
		} else { 
			return null
		}
	}

	getGoogleEventsMetaData() { 
		//TODO: Add offers.
		return `{
			"@context": "https://schema.org",
			"@type": "Event",
			"name": "${this.props.event.title}",
			"startDate": "${this.props.event.start_date}",
			"endDate": "${this.props.event.end_date}",
			"location": {
				"@type": "Place",
				"name": "${this.props.event.place}",
				"address": {
					"@type": "PostalAddress",
					"streetAddress": "${this.props.event.address}"
				}
			}
			"image": [
					"${this.props.event.image_url}"
			],
			"description": "${this.props.event.description}"
			}`
	}

	getBookButton() { 
		const now = moment()
		const eventEnd = moment(this.props.event.end_date)
		const eventOver = now.isAfter(eventEnd)
		if (this.props.event.published == false) { 
			return <Button size="large" variant="dark" block
		  							style={{height:50}}>Not published</Button>
		}
		
		if (eventOver) {
			return (<Button size="large" variant="dark" block
		  							style={{height:50}}>Event Over</Button>)
		} else { 
			return (<Button size="large" variant="dark" block className="event_book"
		  							style={{height:50}}
								  onClick={()=> this.handleClickBook()}>Get Tickets</Button>)
		}
	}

	openInMaps() { 
		ReactGA.event({
			category: 'Event',
			action: 'map_open',
			label: 'event_page'
		})
		window.location.href = "https://www.google.com/maps/search/?api=1&query=" + this.state.event.address
	}

	getMapString() { 
		return "https://www.google.com/maps/embed/v1/place?key=AIzaSyDQ2r7QSoHIKlZJPp19Aj2dnYcZYO54Aac&q=" +  this.props.event.address
	}

	getPromoterMailTo() {
		if (this.props.event.promoter !== null && this.props.event.promoter !== undefined) { 
			const promoter = this.props.event.promoter
			print(`Promoter email is: ${promoter.email}`)
			return `mailto:${promoter.email}?subject=Movement - ${this.props.event.title}`
		}

		print(`promoter is null or undefined`)
	}

	getPromoterDetails() { 
		if (this.props.event.promoter !== null && this.props.event.promoter !== undefined) { 
			const promoter = this.props.event.promoter
			return <div>
			<UserCellView
				image_url={promoter.image}
				title={"Organizer of " + this.props.event.title}
				username={promoter.username}
				bio={promoter.about}
				email={promoter.email}
				handleNameClick={() => {
						ReactGA.event({ 
							category: 'User',
							action: 'view_promoter_profile',
							label: promoter.id.toString()
						})
						Router.push("/o/" + promoter.id)
					}
				}
			/>
			<Divider />
			</div>
		}
	}

	getPromoterNameAndLink() { 
		const promoter = this.props.event.promoter
		if (promoter !== null && promoter !== undefined) { 
			return <Button variant="link" 
			style={{padding:0, marginBottom: 10}}
			onClick={() => Router.push('/o/' + promoter.id)}
			>by {this.props.event.promoter.username}
			</Button>
		}
	}

	render() {

		if (this.props.event == null || this.props.event == undefined) { 
			//TODO: Add loading
			return <p>Theres nothing here</p>
		}

		if (this.state.embed == true) { 
			return <div>
					<BookingModal show={true}
						event={this.props.event}
						noModal/>
					</div>
		}

		return <Layout
				user={this.props.user}
				title={this.props.event.title + " - ETA"}
				imageUrl={this.props.event.image_url}
				description={this.props.event.description}
				// showHeaderSearch
				stickyHeader={false}
				noContainer
				>
				<Head>
					{/* <meta name="apple-itunes-app" content="app-id=1448003243, affiliate-data=banner_event_website" /> */}
					<>
					{this.props.event && <script type="application/ld+json" dangerouslySetInnerHTML={{__html: this.props.jsonLdStr}}></script>}
					{this.props.event && <link rel="canonical" href={`https://www.witheta.com/event/${this.utilsManager.slugify(this.props.event.title)}-${this.props.event.id}`} />}
					</>
				</Head>
				{!this.deviceInfo.isMobile && <Container style={{backgroundColor: 'white'}}>
					{this.getBody()}
				</Container>}

				{this.deviceInfo.isMobile && <div style={{backgroundColor: 'white'}}>
					{this.maybeGetShareView()}
					{this.getBody()}
				</div> }
				<style global jsx>{
					`img { 
						max-width: 100%;
					}
					p { 
						word-break: break-word;
					}
					`
				}</style>	
		</Layout>
	}

	isForTheCultureEvent() { 
		if (this.props.appDomain === "witheta") { 
			return true;
		}
		const zone = this.props.event.zone
		var forTheCulture = false;
		if (!this.props.event.community) { 
			return false;
		}

		if (zone) { 
			const config = zone.config;
			const communityIds = config.client.community_ids;
			if (communityIds.for_the_culture === this.props.event.community.id) { 
				forTheCulture = true;
			}
		}
		return forTheCulture;
	}

	getBody() { 
		var playerModal = this.getPlayerModal()
		var infoModal = this.getInformationModal()
		const hasShareView = this.maybeGetShareView()
		return (<div>
			{!hasShareView && <DownloadPlug simple id="event_page"></DownloadPlug>}
			<div style={{marginBottom:20, zIndex: 3, position: 'relative'}}>
					{!this.deviceInfo.isMobile && <Row style={{display: 'flex', flexDirection: 'row'}}>
							<Col>
								<div style={{height: 350, width: 700, backgroundPosition: 'center', backgroundImage: `url(${this.state.event.image_url})`, backgroundSize: 'cover',
									backgroundPosition: 'center', justifyContent: "center" }}>
								</div>
							</Col>
							<Col>
								<div style={{padding: 5, marginTop: 10,  textAlign: 'center', textAlign: 'left', color: 'black'}}>
										<h1>{this.props.event.title}</h1>
										{this.getPromoterNameAndLink()}
										<p > {this.getStartTimeAndEndTime()}</p>
										<p ><strong>{this.getCost()}</strong></p>
								</div>
							</Col>
						</Row>}

					{this.deviceInfo.isMobile && <Card>
						<div style={{paddingTop: '66.66%', backgroundPosition: 'center', backgroundImage: `url(${this.state.event.image_url})`, backgroundSize: 'cover',
					backgroundPosition: 'center'}}>
						</div>
					</Card>}
					
			</div>

				{this.deviceInfo.isMobile && <Container>
					{this.getInnerBody()}
				</Container>}
						

						
				{!this.deviceInfo.isMobile && this.getInnerBody()}

					{!this.props.guideId && this.isForTheCultureEvent() && <DownloadPlug
						id={"see_more_event_page"}
						title={"Discover more experiences for the culture."}
						body={"See more curated events, chat with others in the city and get notified about new events."}
					/>}
{/* 
					{this.state.config && this.state.config.iframe_code && <Container>
						<div dangerouslySetInnerHTML={{ __html: this.state.config.iframe_code }} />
					</Container>} */}

					{this.props.aff !== "passport" && this.props.similarEvents && this.props.similarEvents.length > 0 && 
						<Container>
						<ItemRow
							isMobile={this.deviceInfo.isMobile}
							items={this.props.similarEvents}
							allowHorizontalOverflow
							aff="mvmntsim"
							title={this.isForTheCultureEvent() ? "Other similar dope events" : "Similar events" }
							onEventClick={(eventId) => {
								ReactGA.event({ 
									category: 'Event',
									action: 'click_see_more_events',
									label: eventId.toString()
									})
								this.metricsManager.logEvent("other_events_click", {});
								// window.location.href="/event/" + eventId + "?aff=mvmntsim"
							}
						}
						/>
						</Container>
					}

					{infoModal}
					{playerModal}
					{this.props.event.event_telemetry !== undefined && <EventTelemetryOverlay 
						eventTelemetry={this.getTelemetryData()}
						eventName={this.props.event.title}
					/>}
					<BookingModal 
						show={this.state.show}
						handleClose={() => this.handleClose()}
						event={this.props.event}
						isForTheCulture={this.isForTheCultureEvent()}
					/>

			</div>)
	}

	maybeGetShareView() { 
		if (this.state.share === true && this.isForTheCultureEvent()) { 
			var user = "Someone"
			if (this.state.username !== null && this.state.username !== undefined) { 
				user = this.state.username
			}
			return <DownloadPlug
			title={`${user} sent you this event they discovered on ETA`}
			body={"Join over 10k members by downloading the app to discover more experiences for the culture and stay in the know ✊🏽"}
			id={"share_mobile"}/>
		} else { 
			return null
		}
	}

	getEventAbout() { 
		if (this.props.event.body_html) { 
			return <div dangerouslySetInnerHTML={{ __html: this.props.event.body_html }}/>
		} else { 
			return 	<p style={{whiteSpace:'pre-line', 'color': '#6F7287', wordBreak: 'break-word'}}>
			{this.props.event.description}
		</p>
		}
	}

	getLocationView(mobile = false) { 
		return <div style={{marginTop:20, display:'flex'}}>
		<div>
		  <MdLocationOn style={{marginTop: 3, marginRight:10}}/>
	  </div>
	  <div>
		  {!this.props.event.venue && <p style={{marginBottom:0}}>{this.props.event.online ? "Online" : this.props.event.place}</p>}
		  {this.props.event.venue && <a href={`/place/${canoc(this.props.event.place, this.props.event.venue.id)}?zone=${this.props.event.zone ? this.props.event.zone.slug : null}`}>
			  <p style={{marginBottom:0, color: 'black', textDecoration: 'underline'}}>{this.props.event.online ? "Online" : this.props.event.place}</p></a>}

		  <p style={{size:'6', color:'gray'}}>{this.props.event.online ? "Online": this.props.event.address}</p>
		  {!this.props.event.online && <Button style={{marginBottom:20}} 
		  variant="outline-dark"
		  onClick={()=>this.openInMaps()}>Open in Google Maps</Button>}
	  </div>
  </div>
	}

	getCost() { 
		if (this.props.event.cost === 0) { 
			return "Free"
		} else { 
			return "from $" + this.props.event.cost
		}
	}

	getInnerBody() { 
		return (<React.Fragment>
					{this.deviceInfo.isMobile ? <>
							<div style={{padding: 10}}>
						<h1>{this.props.event.title}</h1>
						{this.getPromoterNameAndLink()}
						<p> {this.getStartTimeAndEndTime()}</p>
						<p><strong>{this.getCost()}</strong></p>
						</div>
						 <div style={{marginBottom:30}}>
							  {this.getBookButton()}
						  </div>
						{this.getLocationView(true)}
						</> : null}
						

					<Row>
						<Col md="8">
							{this.getVideos()}

							{/* <LiveViewButton event={this.props.event} divStyle={Constants.centeredDiv}/> */}

							{this.props.event.tags && <div style={{cursor: 'pointer'}}>
								{this.props.event.tags.map((item, index) => <Badge 
									onClick={() => alert(item.description)}
									style={{marginRight: '5px'}} variant="info">{item.label}</Badge>)}
							</div>}

							<Divider />
							<h3>About </h3>

							{this.getEventAbout()}


							<Divider/>
							{ /* GET TIPS??*/}

							{this.getPromoterDetails()}

							{!this.props.event.online && <div><iframe
	  							width="100%"
	  							height="200"
	  							frameBorder="0" style={{border:0}}
	  							src={this.getMapString()}  allowFullScreen>
							</iframe>
							<Divider /> 
							</div>}							

							{this.getChat()}

						</Col>
						
						{!this.deviceInfo.isMobile && <Col style={{marginTop: 20}}>
								  {this.getBookButton()}
								  {this.getLocationView(false)}
						</Col>}
					</Row>
			</React.Fragment>)
	}

	getPlayerModal() { 
		return (
			<VideoPlayerModal
				url={this.state.videoUrl}
				showStory={this.state.showStory}
				handleHide={() => this.setState({showStory:false})}
			/>
		)
	}

	getTelemetryData() { 
		if (this.state.fakeData) {
			var now = new Date()
			return [
				{
					first_name: "Victor", 
					created_at: moment(now).subtract(3, 'minutes').toDate()
				},
				{
					first_name: "Kasey", 
					created_at: moment(now).subtract(4, 'minutes').toDate()
				},
				{
					first_name: "Adrian", 
					created_at: moment(now).subtract(6, 'minutes').toDate()
				}
			]
		} else {
			
			return this.props.event.event_telemetry
		}
	}
}

export default connect(state => state)(withRouter(Event))